import { render, staticRenderFns } from "./PaidEventsConfigurationModal.vue?vue&type=template&id=34311fe8&scoped=true&"
import script from "./PaidEventsConfigurationModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PaidEventsConfigurationModal.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./PaidEventsConfigurationModal.vue?vue&type=style&index=0&id=34311fe8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34311fe8",
  null
  
)

export default component.exports